import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { SesionServicio } from '@nucleo/sesion/sesion-servicio';
import { OMITIR_AUTORIZACION } from '@nucleo/http/contexto-peticion-util';
import { RUTAS_APP } from '@app/rutas/app-rutas.const';

/**
 * Ante un 401 la sesión ya no es válida (el token se renueva por adelantado, así que un 401 significa
 * sesión revocada, refresh vencido o reusado): se limpia y se envía a "sesión caducada".
 * Se registra ANTES de `cabecerasApiInterceptor` para capturar también el 401 de una renovación fallida.
 * Las peticiones `OMITIR_AUTORIZACION` (`/auth/*`) se ignoran: en el login un 401 es "credenciales inválidas".
 */
export const errorApiInterceptor: HttpInterceptorFn = (peticion, siguiente) => {
  const servicioSesion = inject(SesionServicio);
  const router = inject(Router);

  return siguiente(peticion).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === HttpStatusCode.Unauthorized &&
        !peticion.context.get(OMITIR_AUTORIZACION) &&
        servicioSesion.sesion() !== null
      ) {
        servicioSesion.limpiar();
        router.navigateByUrl(RUTAS_APP.AUTENTICACION.absolutas.sesionCaducada());
      }
      return throwError(() => error);
    }),
  );
};
